import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Checkbox from '..';

import './index.css';

class BlueCheckbox extends Component {
  constructor(props) {
    super(props);

    this.getClassNames = this.getClassNames.bind(this);
  }

  getClassNames() {
    const { className } = this.props;
    return classnames({
      BlueCheckbox: true,
      [className]: true,
    });
  }

  render() {
    const { getClassNames } = this;
    return <Checkbox {...this.props} className={getClassNames()} />;
  }
}

BlueCheckbox.propTypes = {
  className: PropTypes.string,
};

BlueCheckbox.defaultProps = {
  className: '',
};

export default BlueCheckbox;
